document.addEventListener('DOMContentLoaded', () => {
  const banner = document.getElementById('cookie-banner')
  const acceptBtn = document.getElementById('cookie-accept')
  const footer = document.getElementById('page-footer')

  if (!banner || !acceptBtn) return

  const updateFooterPadding = () => {
    if (!footer) return

    footer.style.setProperty('--footer-padding-bottom', `${banner.offsetHeight}px`)
  }

  const resetFooterPadding = () => {
    footer?.style.removeProperty('--footer-padding-bottom')
  }

  // Проверяем, было ли уже принято согласие
  if (localStorage.getItem('cookie_consent') === 'accepted') {
    banner.style.display = 'none'
    resetFooterPadding()
    //initAnalytics()
    return
  }

  // Показываем баннер
  banner.classList.add('cookie-banner--visible')
  updateFooterPadding()
  $(window).on('resize:width', updateFooterPadding)

  acceptBtn.addEventListener('click', () => {
    localStorage.setItem('cookie_consent', 'accepted')
    $(window).off('resize:width', updateFooterPadding)
    resetFooterPadding()
    banner.classList.remove('cookie-banner--visible')
    banner.classList.add('cookie-banner--hidden')
    setTimeout(() => {
      banner.style.display = 'none'
    }, 300)

    //initAnalytics()
  })
})

//function initAnalytics() {
//  // Yandex Metrika — ym() уже определён как заглушка в head.html,
//  // вызовы ставятся в очередь. Загружаем скрипт — он обработает очередь.
//  if (document.referrer) {
//    const ymScript = document.createElement('script')
//    ymScript.async = true
//    ymScript.src = 'https://mc.yandex.ru/metrika/tag.js'
//    document.head.appendChild(ymScript)
//
//    ym(43575739, 'init', {
//      clickmap: true,
//      trackLinks: true,
//      accurateTrackBounce: true,
//      webvisor: true,
//      trackHash: true,
//    })
//  }

  // // Google Analytics — обновляем consent и загружаем скрипт
  // gtag('consent', 'update', {
  //   analytics_storage: 'granted',
  //   ad_storage: 'granted',
  // })

  // const gaScript = document.createElement('script')
  // gaScript.async = true
  // gaScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-ZEWR95CQ2J'
  // document.head.appendChild(gaScript)

  // gaScript.onload = function () {
  //   gtag('js', new Date())
  //   gtag('config', 'G-ZEWR95CQ2J')
  // }
//}
